module.exports = "<p>\r\n  shop-discounts-page works!\r\n</p>\r\n"